import { useState, useEffect } from 'react';
import { map } from 'lodash'

import compresionLecDB from '../../../documents/Primaria/compresionLectora.json';

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import ReturnBar from '../../../components/ReturnBar/ReturnBar';
import CardAll from '../../../components/Cards/CardAll/CardAll';
import PdfModal from '../../../components/Modal/PdfModal/PdfModal';
import './CompresionLectora.scss';

export default function CompresionLectora() {

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [contentModal, setContentModal] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setData(compresionLecDB);
        setIsLoading(false);
    }, []);

    return (
        <div className="compresion-lectora">
            <ReturnBar />
            {
                isLoading ? (
                    <div className="compresion-lectora__loading">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Container>
                        <h2 className="compresion-lectora__titulo">Compresión Lectora</h2>
                        <Row>
                            {
                                map(data, items => (
                                    <Col lg={12} md={12} className="gy-5" key={items.id} >
                                        <CardAll
                                            element={items}
                                            setShowModal={setShowModal}
                                            setTitleModal={setTitleModal}
                                            setContentModal={setContentModal}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                )
            }

            <PdfModal show={showModal} setShow={setShowModal} title={titleModal}>
                {contentModal}
            </PdfModal>
        </div>
    );
}